import { api } from '@/lib/axios';
import type { ModuleKey } from '@symphenia/shared-types';

/** AP-29-H — Platzvergabe durch den Mandanten (ADMIN). */

export interface SeatUser {
  id: string;
  email: string;
  firstName: string | null;
  lastName: string | null;
  /** AP-30 Stufe 3: zugewiesene Rollen statt eines Rangs. */
  roles: { key: string; name: string }[];
  assigned: boolean;
}

export interface SeatOverview {
  module: {
    key: ModuleKey;
    seatMode: 'ALL_USERS' | 'ASSIGNED';
    seats: number | null;
    seatsUsed: number;
    /** Zuteilungen deaktivierter Benutzer — sie zählen nicht mit. */
    seatsDormant: number;
  };
  users: SeatUser[];
}

export const moduleSeatsApi = {
  getOverview: async (moduleKey: string): Promise<SeatOverview> => {
    const res = await api.get<SeatOverview>(`/module-seats/${moduleKey}`);
    return res.data;
  },

  /** Setzt die Zuteilung auf **genau** diese Benutzer — wer fehlt, verliert den Platz. */
  setSeats: (moduleKey: string, userIds: string[]) =>
    api.put<{ seatsUsed: number }>(`/module-seats/${moduleKey}`, { userIds }),
};
